import { BreadcrumbItemProps } from '@gerdau/hefesto-mais-web/Breadcrumbs/Breadcrumbs.types';
import { useLocation } from 'react-router-dom';
import {
  headerTextContent,
  pageBreadCrumbs,
  possibleBreadcrumbRoutes
} from './enum/purchase-header.texts';
import { EOrderSettingsRoutes } from '../OrderSettingsMvp/orderSettings.routes';

const usePurchaseSubheader = () => {
  // ? Esse componente precisa funcionar também como um stepper, e acompanhar as telas e saber em qual passo está.
  // TODO: Melhorar o componente
  const { pathname } = useLocation();
  const selectedItemNav = pathname.split('/').pop();
  const productDetailsBreadcrumb = [
    {
      name: 'Comprar',
      url: 'steel-type-choose'
    },
    {
      name: 'Comprar por vitrine',
      url: 'catalog'
    },
    {
      name: 'Detalhes do produto',
      url: '/'
    }
  ];
  const breadcrumb: BreadcrumbItemProps[] =
    selectedItemNav &&
    possibleBreadcrumbRoutes.includes(selectedItemNav as EOrderSettingsRoutes)
      ? pageBreadCrumbs[selectedItemNav]
      : productDetailsBreadcrumb;

  const headerText =
    selectedItemNav && headerTextContent[selectedItemNav]
      ? headerTextContent[selectedItemNav]
      : {
          title: 'Detalhes do produto',
          supportText: 'Confira produtos similares e mais informações eles.'
        };
  return {
    breadcrumb,
    headerText
  };
};

export default usePurchaseSubheader;
